<template>
  <div class="subjects-wrapper">
    <vs-table
      :multiple="multiple"
      no-data-text="No tienes destinatarios"
      v-model="subjectsSelected"
      :data="subjects"
      class="table"
    >
      <template slot="thead">
        <vs-th>Destino</vs-th>
        <vs-th>Lista Destino</vs-th>
        <vs-th>Extra</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
          <vs-td :data="data[indextr].subjectType.label">
            {{tr.subjectType.label}}
          </vs-td>
          <vs-td :data="data[indextr].subject.label">
            {{tr.subject.label}}
            <div v-if="isExternSubjects.includes(tr.subjectType.value)">
              <span>
                {{tr.subjectEmail}}
              </span>
            </div>
          </vs-td>
          <vs-td
            v-if="data[indextr].subjectTypeDigitalDoc.label"
            :data="data[indextr].subjectTypeDigitalDoc.label"
          >
            {{tr.subjectTypeDigitalDoc.label}}
            <small class="d-block">institución</small>
          </vs-td>
          <vs-td
            v-if="data[indextr].providence"
            :data="data[indextr].providence"
          >
            {{providencesMap[tr.providence]}}
            <span v-if="data[indextr].providenceExpiration">
             - {{tr.providenceExpiration | dateFormat}}
          </span>
            <small class="d-block">providencia</small>
          </vs-td>
          <vs-td
            v-if="tr.subjectType.value === 'sanitarias'"
            :data="data[indextr].subjectEmail"
          >
          <span>
            {{tr.subjectEmail}}
          </span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';

export default {
  data() {
    return {
      isExternSubjects: [
        'personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'
      ],
      providencesMap: ProvidencesMap,
      subjectsSelected: this.value || []
    };
  },
  watch: {
    subjectsSelected() {
      this.$emit('input', this.subjectsSelected);
    },
    value(newValue) {
      this.subjectsSelected = newValue;
    }
  },
  methods: {
    formatEmails(emails) {
      return emails.correos || '';
    }
  },
  props: {
    subjects: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
<style>
.subjects-wrapper {
  max-height: 600px;
  overflow: scroll;
}
</style>
